export default (axios) => ({
  getCart() {
    return axios.get(`/carts`);
  },
  createCart(payload) {
    return axios.get("/carts",payload||{});
  },
  updateCart(cartid,payload) {
    return axios.put(`/carts/${cartid}`,payload||{});
  },
  createCartItem(payload) {
    return axios.post("/carts/items", payload);
  },
  updateCartItem(id,payload) {
    return axios.put(`/carts/items/${id}`, payload);
  },
  deleteCartItem(id){
    return axios.delete(`carts/items/${id}`);
  },
  fetchInternalOrder(id){
    return axios.get(`orders/${id}`);
  }
});
